<template>
<span>
	<transition name="slide">
		<div v-if="show" class="bill-filter-mask">
			<div class="bill-filter-wrapper">
				<a class="bill-filter-cancel" @click="cancel">取消</a>
				<navbar title="供货商对账单筛选"></navbar>
				<div class="summary-filter-shell">
					<ul class="summary-filter-ul">
						<li style="background: none">开始日期：&nbsp; 
							<input class="bill-filter-date" type="date" v-model="start_date" /> 
						</li>
						<li style="background: none">结束日期：&nbsp; 
							<input class="bill-filter-date" type="date" v-model="end_date" />
						</li>
						<li @click="selectBillStatus(billState, billStateFont)">单据状态：&nbsp; <span>{{billStateFont}}</span></li>
					</ul>
					<a class="summary-filter-btn" @click="printData">确定</a>
				</div>			
			</div>
		</div>
	</transition>
	<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
	<bill-status-select ref="billStatuselectShow"  title="单据统计-选择退单状态"
		v-on:confirm="getBillStatus"
		:billStatusFlag="billState" :billStateFont="billStateFont"
	></bill-status-select>
</span>
</template>
<script>
import Tips from '../components/Tips'
import NavBar from '../components/NavBar'
import BillStatusSelect from '../components/BillStatusSelectSupplierAccountCheck'
import { GlobalStore } from '../store/globalStore'
export default {
	props: {
		filterBillState: String,
		filterBillFont: String,
		filterStarDate: String,
		filterEndDate: String
	},
	data () {
		return {
			tips: false,
			msg: [],
			btnNum: 1,
			tipsFont: '',
			show: false,
			start_date: '',
			end_date: '',
			billState: '',
			billStateFont: '',
			store: GlobalStore,
			billFilterData: {}
		}
	},
	components: {
		'tips': Tips,
		'navbar': NavBar,
		'bill-status-select': BillStatusSelect
	},
	created () {
		this.billState = this.filterBillState
		this.billStateFont = this.filterBillFont
		this.start_date = this.filterStarDate // 设置默认时间 shang 2017/10/19
		this.end_date = this.filterEndDate
		this.billFilterData = this.store.billFilterData
	},
	methods: {
		move (obj) {
			this.show = !this.show
			this.billState = obj.back_state
			this.billStateFont = obj.back_state_font
		},
		getBillStatus (msg) {
			this.billState = msg[0].join(',')
			this.billStateFont = msg[1].join(',')
		},
		selectBillStatus (flag, font) {
			this.$refs.billStatuselectShow.open(flag, font)
		},
		tipStatus (msg) {
			this.tips = msg[0]
		},
		belong (val) {
			if (this.billState.indexOf(val) !== -1) {
				return true
			} else {
				return false
			}
		},
		selectState (val) {
			var index = this.billState.indexOf(val)
			if (index === -1) {
				this.billState.push(val)
				return false
			} else {
				this.billState.splice(index, 1)
				return false
			}
		},
		printData () {
			if (this.billState.length === 0) {
				this.tips = true
				this.tipsFont = '请至少选择一种单据状态'
				return false
			}
			this.show = false
			// 查询条件全局保存 shang 2017/10/19
			this.billFilterData.filterFlag = true
			this.billFilterData.filterStartDate = this.start_date
			this.billFilterData.filterEndDate = this.end_date
			this.billFilterData.filterBillState = this.billState
			this.billFilterData.filterBillStateFont = this.billStateFont
			var msg = {
				bill_state_font: this.billStateFont,
				bill_state: this.billState,
				start_date: this.start_date,
				end_date: this.end_date
			}
			this.$emit('confirm', msg)
		},
		cancel () {
			this.show = false
		}
	}
}
</script>


// WEBPACK FOOTER //
// SupplierAccountCheckBillFilter.vue?402367ba